export default __webpack_public_path__ + "790409272ece12028437b1f0fdc2ab59.png";